import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
import { CrossSellPanel, FeatureFlag } from '@cart-js/trip';
import { mapStateToProps, OwnProps, HomeCrossSellPanelProps } from 'component/page/home/CrossSell/HomeCrossSellPanel.selectors';
import { Box } from '@drone-js/core';
import { withErrorBoundary } from 'component/common/Hoc/ErrorBoundary';

const HomeCrossSellComponent: React.FC<HomeCrossSellPanelProps> = (props) => {
    return (
        <Box display="flex" flexDirection="column" width="100%" mb="48">
            <CrossSellPanel
                pageTypeId={props.pageTypeId.toString()}
                body={{ isUpcomingBookingRequired: true, searchCriteriaRequest: [], featureFlags: [FeatureFlag.DetailedFlightCrossSell] }}
                hideBorder={true}
                username=""
                displayLoading={false}
                namespace={props.namespace}
            />
        </Box>
    );
};

HomeCrossSellComponent.displayName = 'HomeCrossSellComponent';
const HomeCrossSellPanel = compose<React.FC<OwnProps>>(connect(mapStateToProps))(withErrorBoundary(HomeCrossSellComponent, undefined, undefined, '20%'));
HomeCrossSellPanel.displayName = 'HomeCrossSellPanel';

export { HomeCrossSellPanel };
